import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

// actions
import { getGroups as fetchGroups } from '../../store/actions/groups';

// selectors
import { getFilteredGroups } from '../../store/selectors/groups';

const useGroups = () => {
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch();
  const { t } = useTranslation()
  const groups = useSelector(getFilteredGroups);

  const getGroups = async (searchText = '') => {
    try {
      setIsLoading(true);
      const res = await dispatch(fetchGroups(searchText)).unwrap();
      const groupsResources = res.resources
      if (groupsResources.length === 0) {
        toast.error(t('no-matching-records'))
      }
    } catch (error) {
      toast.error(error?.message)
    } finally {
      setIsLoading(false)
    }
  };

  return { groups, areGroupsLoading: isLoading, getGroups };
};

export default useGroups;
